import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { setAuthenticated } from '@bechtel/client-common';

// NOTE: at this point the JWT has already been saved to our device
// as a secure httpOnly cookie so we do not have access to it.
export const AuthCallback = () => {
  useEffect(() => {
    // NOTE: Since we cannot acess the cookie via Document.cookie
    // we create a flag for usage in our React router authentication checks
    setAuthenticated();
  }, []);

  // return null;
  return <Navigate to="/" replace />;
};
